import PropTypes from "prop-types";
import { PureComponent } from "react";

import { FormattedMessage, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';

import { withIdentity } from 'mastodon/identity_context';

class FavouritesTooltip extends PureComponent {
  static propTypes = {
    accounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      username: PropTypes.string,
      acct: PropTypes.string,
      display_name: PropTypes.string,
      avatar: PropTypes.string,
      url: PropTypes.string,
    })),
    totalCount: PropTypes.number,
  };

  handleAccountClick = e => {
    e.stopPropagation();
  };

  render() {
    const { accounts, totalCount } = this.props;
    const maxDisplay = 8;
    const visibleAccounts = accounts.slice(0, maxDisplay);
    const remainingCount = Math.max((totalCount ?? accounts.length) - visibleAccounts.length, 0);

    return (
      <div className='favourites-tooltip visible'>
        {accounts.length > 0 && (
          <>
            <ul>
              {visibleAccounts.map(account => (
                <li key={account.acct}>
                  <Link to={`/@${account.acct}`} onClick={this.handleAccountClick}>
                    <span>{account.display_name || account.acct}</span>
                  </Link>
                </li>
              ))}
            </ul>
            {remainingCount > 0 && (
              <p className='favourites-tooltip__others'>
                <FormattedMessage
                  id='status.others_like'
                  defaultMessage='Others {count} like.'
                  values={{ count: remainingCount }}
                />
              </p>
            )}
          </>
        )}
      </div>
    );
  }
}

export default withIdentity(injectIntl(FavouritesTooltip));
